'use client';
import { LicenseInfo } from '@mui/x-license';

LicenseInfo.setLicenseKey('ff23b1b89dc855739d21ce57a900ef00Tz0xMDcwMDgsRT0xNzY5OTAzOTk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=');

export default function MuiXLicense() {
  return null;
}